import { LINKEDIN_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/linkedin-utils';
import { SummaryPanelView } from './summary-panel-view';

const PerformanceEstimationsConfig = {
  title: _TL_('Performance'),
  ariaLabel: _TL_('Click here to toggle the performance panel'),
  toolTipText: _TL_('Performance'),
  view: SummaryPanelView,
};

export const summaryPanelConfig = [
  {
    id: LINKEDIN_WIZARD_STEP_PATHS.TARGETING,
    ...PerformanceEstimationsConfig,
  },
  {
    id: LINKEDIN_WIZARD_STEP_PATHS.BUDGET,
    ...PerformanceEstimationsConfig,
  },
  {
    id: LINKEDIN_WIZARD_STEP_PATHS.SUMMARY,
    ...PerformanceEstimationsConfig,
  },
];
